import { render, staticRenderFns } from "./userBuyRecord.vue?vue&type=template&id=6f423de2&scoped=true&"
import script from "./userBuyRecord.vue?vue&type=script&lang=ts&"
export * from "./userBuyRecord.vue?vue&type=script&lang=ts&"
import style0 from "./userBuyRecord.vue?vue&type=style&index=0&id=6f423de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f423de2",
  null
  
)

export default component.exports